import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const MovieSlider = () => {
  const cardSlider = new Swiper('.intro__movie--slider', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 30,
    centeredSlides: true,
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
};

export default MovieSlider;
